var _path, _path2, _rect, _path3, _rect2, _path4, _path5, _path6, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-255"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.69,
    y: 300.63,
    width: 81.48,
    height: 75.92,
    transform: "translate(672.85 677.17) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.21,
    y: 378.93,
    width: 10.4,
    height: 3.63,
    transform: "translate(738.81 761.5) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.23,
    y: 300.63,
    width: 165.45,
    height: 75.19,
    transform: "translate(425.92 676.44) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.6,
    y: 295.03,
    width: 25.4,
    height: 87.54,
    transform: "translate(230.6 677.6) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.89,
    y: 306.61,
    width: 71.73,
    height: 65.69,
    transform: "translate(503.51 678.91) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.68,
    y: 306.61,
    width: 71.73,
    height: 65.69,
    transform: "translate(667.09 678.91) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.33,
    y: 306.61,
    width: 71.73,
    height: 65.69,
    transform: "translate(338.38 678.91) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.88,295v87.54h5.54v-2.08H374.58v2.08h5.55V295H127.88Zm246.7,39.64H298.37V303.23h76.21ZM298.37,372.3V339.35h76.21V372.3Zm-82.48-69.07h76.93V372.3H215.89Zm-82.47,36.12h76.93V372.3H133.42Zm0-36.12h76.93v31.44H133.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.54,315.29h12a2.33,2.33,0,0,0,2.34-2.33h0a2.33,2.33,0,0,0-2.34-2.33h-12a2.33,2.33,0,0,0-2.33,2.33h0A2.33,2.33,0,0,0,327.54,315.29Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.21,344.22v-12a2.33,2.33,0,0,0-2.33-2.33h0a2.33,2.33,0,0,0-2.34,2.33v12a2.33,2.33,0,0,0,2.34,2.33h0A2.33,2.33,0,0,0,226.21,344.22Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.54,349h12a2.33,2.33,0,0,0,2.34-2.33h0a2.34,2.34,0,0,0-2.34-2.34h-12a2.33,2.33,0,0,0-2.33,2.34h0A2.33,2.33,0,0,0,327.54,349Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19,315.29h12a2.33,2.33,0,0,0,2.33-2.33h0a2.33,2.33,0,0,0-2.33-2.33h-12a2.33,2.33,0,0,0-2.33,2.33h0A2.33,2.33,0,0,0,163.19,315.29Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19,349h12a2.33,2.33,0,0,0,2.33-2.33h0a2.33,2.33,0,0,0-2.33-2.34h-12a2.33,2.33,0,0,0-2.33,2.34h0A2.33,2.33,0,0,0,163.19,349Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.93,
    y: 159.1,
    width: 23.72,
    height: 221.74,
    transform: "translate(165.59 539.94) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,157.16V382.78H70.93V157.16Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.77,157.16V382.78h18.48V157.16Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.72,157.16V382.78h46.66V157.16ZM111,161.05V201.5H73.15V161.05ZM73.15,290.2V249.74H111V290.2Zm37.8,3.89v40.46H73.15V294.09Zm-37.8-48.24V205.4H111v40.45Zm0,133V338.44H111v40.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.28,
    y: 170.48,
    width: 5.51,
    height: 31.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.02,
    y: 170.48,
    width: 4.26,
    height: 31.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.79,
    y: 171.23,
    width: 8.52,
    height: 30.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.31,
    y: 171.23,
    width: 4.26,
    height: 30.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.49,
    y: 171.23,
    width: 5.68,
    height: 30.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.18,
    y: 171.23,
    width: 2.84,
    height: 30.65,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.28,
    y: 214.44,
    width: 5.51,
    height: 31.39,
    transform: "translate(178.07 460.28) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.79,
    y: 214.44,
    width: 4.26,
    height: 31.39,
    transform: "translate(187.84 460.28) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.76,
    y: 215.19,
    width: 8.52,
    height: 30.65,
    transform: "translate(164.04 461.02) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.49,
    y: 215.19,
    width: 4.26,
    height: 30.65,
    transform: "translate(151.25 461.02) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.89,
    y: 215.19,
    width: 5.68,
    height: 30.65,
    transform: "translate(203.47 461.02) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.05,
    y: 215.19,
    width: 2.84,
    height: 30.65,
    transform: "translate(194.94 461.02) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.28,
    y: 259.18,
    width: 5.51,
    height: 31.39,
    transform: "translate(178.07 549.75) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.79,
    y: 259.18,
    width: 4.26,
    height: 31.39,
    transform: "translate(187.84 549.75) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.76,
    y: 259.92,
    width: 8.52,
    height: 30.65,
    transform: "translate(164.04 550.49) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.49,
    y: 259.92,
    width: 4.26,
    height: 30.65,
    transform: "translate(151.25 550.49) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.89,
    y: 259.92,
    width: 5.68,
    height: 30.65,
    transform: "translate(203.47 550.49) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.05,
    y: 259.92,
    width: 2.84,
    height: 30.65,
    transform: "translate(194.94 550.49) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.28,
    y: 303.92,
    width: 5.51,
    height: 31.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.02,
    y: 303.92,
    width: 4.26,
    height: 31.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.79,
    y: 303.92,
    width: 8.52,
    height: 30.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.31,
    y: 303.92,
    width: 4.26,
    height: 30.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.49,
    y: 303.92,
    width: 5.68,
    height: 30.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.18,
    y: 303.92,
    width: 2.84,
    height: 30.65,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.28,
    y: 348.65,
    width: 5.51,
    height: 31.39,
    transform: "translate(178.07 728.69) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.79,
    y: 348.65,
    width: 4.26,
    height: 31.39,
    transform: "translate(187.84 728.69) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.76,
    y: 348.65,
    width: 8.52,
    height: 30.65,
    transform: "translate(164.04 727.95) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.49,
    y: 348.65,
    width: 4.26,
    height: 30.65,
    transform: "translate(151.25 727.95) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.89,
    y: 348.65,
    width: 5.68,
    height: 30.65,
    transform: "translate(203.47 727.95) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.05,
    y: 348.65,
    width: 2.84,
    height: 30.65,
    transform: "translate(194.94 727.95) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.88,335.9c-.1.11.44.85-1.74.53-5.35-.81-14.69-3-17.28-8.49-3.71-7.87,7.79-5,7.39-9s-13.48-3.33-14.87-9.23,7.49-3.09,7.6-6-10.11-1.09-12.14-7.45,5.7-1.68,4.82-4.33-9.54-14.62-4.84-16,12.64,10.9,15.7,12.64,5.78-8.29,9.43-4.06-2.14,19.05,2.51,21.93c3.47,2.14,2.49-3.76,7.06-2.66C418.74,305.28,416.65,327.21,408.88,335.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.34,303.76a17.81,17.81,0,0,1,4.63.95,33.82,33.82,0,0,0-3.29-4.23.41.41,0,0,1,0-.57.4.4,0,0,1,.56,0,46.56,46.56,0,0,1,6.6,9.57,35.25,35.25,0,0,0-2.61-19.12.3.3,0,0,1,.54-.26c0,.1,4.58,9.57,2.52,20.22.55,1.05,1.1,2.16,1.65,3.36A76.33,76.33,0,0,1,407.47,327a27.37,27.37,0,0,0,3.16-12.11.29.29,0,0,1,.3-.29.29.29,0,0,1,.29.3,27.37,27.37,0,0,1-3.55,12.94,92.4,92.4,0,0,1,2,27.36.41.41,0,0,1-.43.37h-.05a.39.39,0,0,1-.31-.42,87.56,87.56,0,0,0-4.11-34.42,10.91,10.91,0,0,0-6.33-3.62.3.3,0,0,1-.25-.34.29.29,0,0,1,.34-.24,11.19,11.19,0,0,1,5.78,2.87,66.45,66.45,0,0,0-6.77-13.76,16.19,16.19,0,0,0-5.27-1.24A.31.31,0,0,1,392,304,.29.29,0,0,1,392.34,303.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.75,338.94c4.45.08,12.05-4.05,15-8.07s-5.49-1.55-4.62-4.76,11.38-.84,13.32-5.43-5.64-3.53-5.34-5.88,8.16-1.87,10.68-6.75-4.39-2.15-3.3-4.17,9.74-10.54,6.12-12.31-11.75,7.09-14.47,8.08-3.35-5.13-6.89-2.2-.89,15.73-5.06,17.42c-3.1,1.26-1.78-4.61-5.35-3.13C409.63,314.33,413.94,338.9,415.75,338.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.75,338.94c4.45.08,12.05-4.05,15-8.07s-5.49-1.55-4.62-4.76,11.38-.84,13.32-5.43-5.64-3.53-5.34-5.88,8.16-1.87,10.68-6.75-4.39-2.15-3.3-4.17,9.74-10.54,6.12-12.31-11.75,7.09-14.47,8.08-3.35-5.13-6.89-2.2-.89,15.73-5.06,17.42c-3.1,1.26-1.78-4.61-5.35-3.13C409.63,314.33,413.94,338.9,415.75,338.94Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.22,333.59a.23.23,0,0,1-.16-.13,23.24,23.24,0,0,1-2-11.93.3.3,0,0,1,.32-.28.31.31,0,0,1,.28.32,23.67,23.67,0,0,0,1.8,11.35,91.06,91.06,0,0,1,6.78-14.35,31.31,31.31,0,0,1,4.16-17.46.3.3,0,0,1,.5.32,31,31,0,0,0-4.12,16.22,83.27,83.27,0,0,1,11.38-15.22.4.4,0,0,1,.56,0,.39.39,0,0,1,0,.56A77.93,77.93,0,0,0,428,314a23.39,23.39,0,0,1,8.42-1.49.31.31,0,0,1,.29.31.3.3,0,0,1-.3.29h0a22.8,22.8,0,0,0-9,1.75,94.58,94.58,0,0,0-4.85,8.33,10.08,10.08,0,0,1,8.31-1.46.29.29,0,0,1,.21.36.28.28,0,0,1-.36.21,9.56,9.56,0,0,0-8.78,2.13,80.39,80.39,0,0,0-8.63,32.64.4.4,0,0,1-.4.38h0a.39.39,0,0,1-.38-.41A78.49,78.49,0,0,1,417.22,333.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.22,382.43c-4.25-8-7-19.54-7-24.6a14.11,14.11,0,0,1,5.19-10.8h21.77a14.1,14.1,0,0,1,5.18,10.8c0,5.06-2.79,16.61-7,24.6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,227.14c0-.26,0-.52,0-.77l1.51-.84a11.29,11.29,0,0,0-.56-2.09l-1.73,0a8.46,8.46,0,0,0-.77-1.34l.89-1.47a10.19,10.19,0,0,0-1.54-1.54l-1.47.89a8.46,8.46,0,0,0-1.34-.77l0-1.73a11.29,11.29,0,0,0-2.09-.56l-.84,1.51c-.25,0-.51,0-.77,0s-.52,0-.77,0l-.84-1.51a11.29,11.29,0,0,0-2.09.56l0,1.73a8.46,8.46,0,0,0-1.34.77l-1.48-.89a10.61,10.61,0,0,0-1.53,1.54l.89,1.47a7.75,7.75,0,0,0-.77,1.34l-1.73,0a10.56,10.56,0,0,0-.56,2.09l1.51.84c0,.25,0,.51,0,.77s0,.52,0,.77l-1.51.84a10.56,10.56,0,0,0,.56,2.09l1.73,0a7.75,7.75,0,0,0,.77,1.34l-.89,1.48a11.06,11.06,0,0,0,1.53,1.53l1.48-.89a7.75,7.75,0,0,0,1.34.77l0,1.73a10.56,10.56,0,0,0,2.09.56l.84-1.51c.25,0,.51,0,.77,0s.52,0,.77,0l.84,1.51a10.56,10.56,0,0,0,2.09-.56l0-1.73a7.75,7.75,0,0,0,1.34-.77l1.47.89a10.61,10.61,0,0,0,1.54-1.53l-.89-1.48a8.46,8.46,0,0,0,.77-1.34l1.73,0a11.29,11.29,0,0,0,.56-2.09l-1.51-.84C366,227.66,366,227.4,366,227.14Zm-8.71,5.92a5.92,5.92,0,1,1,5.92-5.92A5.92,5.92,0,0,1,357.25,233.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.62,248.51c0-.39,0-.77-.05-1.15l2.25-1.26A15.05,15.05,0,0,0,356,243l-2.57.05a13.7,13.7,0,0,0-1.16-2l1.33-2.21a15.09,15.09,0,0,0-2.3-2.29l-2.21,1.32a13,13,0,0,0-2-1.15l0-2.58a15.52,15.52,0,0,0-3.13-.84l-1.25,2.26a11.15,11.15,0,0,0-2.31,0l-1.25-2.26a15.52,15.52,0,0,0-3.13.84l0,2.58a13,13,0,0,0-2,1.15l-2.22-1.32a15.49,15.49,0,0,0-2.29,2.29l1.33,2.21a13.7,13.7,0,0,0-1.16,2l-2.58-.05a15.7,15.7,0,0,0-.84,3.13l2.26,1.26c0,.38-.05.76-.05,1.15s0,.77.05,1.15l-2.26,1.26a15.7,15.7,0,0,0,.84,3.13l2.58-.05a13.2,13.2,0,0,0,1.16,2l-1.33,2.21a15.49,15.49,0,0,0,2.29,2.29l2.22-1.32a12.26,12.26,0,0,0,2,1.15l0,2.58a15.52,15.52,0,0,0,3.13.84l1.25-2.26a11.15,11.15,0,0,0,2.31,0l1.25,2.26a15.52,15.52,0,0,0,3.13-.84l0-2.58a12.26,12.26,0,0,0,2-1.15l2.21,1.32a15.09,15.09,0,0,0,2.3-2.29L352.25,256a13.2,13.2,0,0,0,1.16-2l2.57.05a15.05,15.05,0,0,0,.84-3.13l-2.25-1.26C354.6,249.28,354.62,248.9,354.62,248.51Zm-13,5.14a5.14,5.14,0,1,1,5.14-5.14A5.14,5.14,0,0,1,341.58,253.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.16,208.87H140.38a7.66,7.66,0,0,0-7.66,7.67v11.77a7.67,7.67,0,0,0,7.66,7.67h11.78a7.67,7.67,0,0,0,7.66-7.67V216.54A7.66,7.66,0,0,0,152.16,208.87Zm-5.89,22s-6.37-6.94-6.37-10.46a6.37,6.37,0,1,1,12.74,0C152.64,223.9,146.27,230.84,146.27,230.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.27,217.48a2.91,2.91,0,1,0,2.91,2.9A2.9,2.9,0,0,0,146.27,217.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,121H377.57a7.07,7.07,0,0,0-7.08,7.07v12.44a7.07,7.07,0,0,0,7.08,7.07H390a7.06,7.06,0,0,0,7.07-7.07V128A7.06,7.06,0,0,0,390,121Zm1.66,9.09a5.84,5.84,0,0,1-1.13,1.09.08.08,0,0,0-.05.09,8,8,0,0,1-.08,1.39,9.11,9.11,0,0,1-.76,2.79A9.24,9.24,0,0,1,388,137.9a8.26,8.26,0,0,1-4.3,2.4,9.52,9.52,0,0,1-1.76.22,9.11,9.11,0,0,1-5-1.36l-.08,0a6.69,6.69,0,0,0,4.65-1.27,3.19,3.19,0,0,1-2.95-2.18,3.24,3.24,0,0,0,1.35,0h0a3.19,3.19,0,0,1-2.06-1.45,3.12,3.12,0,0,1-.48-1.66,3.23,3.23,0,0,0,1.37.38,3.22,3.22,0,0,1-1.29-1.91,3.06,3.06,0,0,1,.31-2.27,9.12,9.12,0,0,0,6.52,3.28,1.35,1.35,0,0,0-.06-.35,3.08,3.08,0,0,1,.43-2.06,3,3,0,0,1,2.12-1.38,3.09,3.09,0,0,1,2.73.87.17.17,0,0,0,.18.05,6.33,6.33,0,0,0,1.81-.69h0a3.2,3.2,0,0,1-1.25,1.63,5.93,5.93,0,0,0,1.74-.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.51,
    y: 112.84,
    width: 28.45,
    height: 28.45,
    rx: 7.57,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.92,122.54v4a3,3,0,0,1-3,3h-3.83l-4.37,4.37v-4.37a3,3,0,0,1-3-3v-4a3,3,0,0,1,3-3h8.2A3,3,0,0,1,125.92,122.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.75,128.59v3.08a2.31,2.31,0,0,1-2.31,2.31v3.36L128.08,134h-2.94a2.31,2.31,0,0,1-2.31-2.31v-3.08a2.31,2.31,0,0,1,2.31-2.32h6.3A2.31,2.31,0,0,1,133.75,128.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.75,122.79h-7.42a.34.34,0,1,1,0-.68h7.42a.34.34,0,0,1,0,.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.75,124.52h-7.42a.34.34,0,1,1,0-.68h7.42a.34.34,0,1,1,0,.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.68,126.25h-5.35a.34.34,0,1,1,0-.68h5.35a.34.34,0,1,1,0,.68Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-255"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-255",
    cx: 250,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Globe--inject-255"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.9,175.59h-1V164.86a7.81,7.81,0,0,0-7.79-7.8H267.36a8.81,8.81,0,0,1-8.8-8.8V140h1v8.28a7.81,7.81,0,0,0,7.8,7.8h19.75a8.8,8.8,0,0,1,8.79,8.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303,175.8H290a4.76,4.76,0,0,0-4.76,4.75v13a4.76,4.76,0,0,0,4.76,4.75H303a4.76,4.76,0,0,0,4.76-4.75v-13A4.76,4.76,0,0,0,303,175.8Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303,175.8H290a4.76,4.76,0,0,0-4.76,4.75v13a4.76,4.76,0,0,0,4.76,4.75H303a4.76,4.76,0,0,0,4.76-4.75v-13A4.76,4.76,0,0,0,303,175.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.4,177.92a8.94,8.94,0,1,0,8.93,8.93A8.95,8.95,0,0,0,296.4,177.92Zm-1.42,1a10.13,10.13,0,0,0-2.08,3h-2.83A8,8,0,0,1,295,178.93Zm-5.52,3.84h3.06a12.21,12.21,0,0,0-.79,3.58l0,.21h-3.35A8.13,8.13,0,0,1,289.46,182.77Zm.18,8.45a8.07,8.07,0,0,1-1.27-3.78h3.38a12.3,12.3,0,0,0,1,3.78Zm.66.88h2.87a9.6,9.6,0,0,0,2.16,2.73A8,8,0,0,1,290.3,192.1Zm5.66,2.11a8.59,8.59,0,0,1-1.77-2.11H296Zm0-3h-2.25a11.46,11.46,0,0,1-1.07-3.78H296Zm0-4.66h-3.35a10.94,10.94,0,0,1,.86-3.79H296Zm0-4.67h-2.08a8.72,8.72,0,0,1,2.08-2.65Zm8.49,4.67h-3.36v-.21h0a11.9,11.9,0,0,0-.79-3.58h3.06A8,8,0,0,1,304.45,186.56Zm-1.72-4.67h-2.82a10.35,10.35,0,0,0-2.09-3A8,8,0,0,1,302.73,181.89Zm-5.89-2.64a8.55,8.55,0,0,1,2.08,2.64h-2.08Zm0,3.52h2.49a11,11,0,0,1,.87,3.79h-3.36Zm0,4.67h3.32a11.23,11.23,0,0,1-1.07,3.78h-2.25Zm0,6.77V192.1h1.77A8.2,8.2,0,0,1,296.84,194.21Zm.63.62a9.6,9.6,0,0,0,2.16-2.73h2.87A8,8,0,0,1,297.47,194.83Zm5.69-3.61h-3.1a12.3,12.3,0,0,0,1-3.78h3.38A8,8,0,0,1,303.16,191.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Search--inject-255"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336.25,159h-1V148.27a7.79,7.79,0,0,0-7.79-7.79H280.33v-1h47.13a8.8,8.8,0,0,1,8.79,8.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.48,151.22h-13a4.76,4.76,0,0,0-4.76,4.75v13a4.76,4.76,0,0,0,4.76,4.75h13a4.76,4.76,0,0,0,4.76-4.75V156A4.76,4.76,0,0,0,339.48,151.22Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.48,151.22h-13a4.76,4.76,0,0,0-4.76,4.75v13a4.76,4.76,0,0,0,4.76,4.75h13a4.76,4.76,0,0,0,4.76-4.75V156A4.76,4.76,0,0,0,339.48,151.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.5,156.26a5.46,5.46,0,1,0-.77,8.36,1.2,1.2,0,0,0,.34.66l3.39,3.39a1.22,1.22,0,1,0,1.73-1.73l-3.39-3.39a1.2,1.2,0,0,0-.67-.34A5.46,5.46,0,0,0,334.5,156.26Zm-1.16,6.56a3.83,3.83,0,1,1,0-5.41A3.82,3.82,0,0,1,333.34,162.82Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cart--inject-255"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 279.21,
    y: 122.44,
    width: 60.32,
    height: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.07,105.28H336.12a4.75,4.75,0,0,0-4.75,4.76V123a4.75,4.75,0,0,0,4.75,4.76h12.95a4.76,4.76,0,0,0,4.76-4.76V110A4.76,4.76,0,0,0,349.07,105.28Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.07,105.28H336.12a4.75,4.75,0,0,0-4.75,4.76V123a4.75,4.75,0,0,0,4.75,4.76h12.95a4.76,4.76,0,0,0,4.76-4.76V110A4.76,4.76,0,0,0,349.07,105.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.44,122.94a1.69,1.69,0,1,1-1.69-1.69A1.68,1.68,0,0,1,339.44,122.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,122.94a1.69,1.69,0,1,1-1.69-1.69A1.68,1.68,0,0,1,346,122.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.72,120.39H335.9a.46.46,0,0,1-.43-.32l-2.06-6.83a.44.44,0,0,1,.07-.4.45.45,0,0,1,.36-.18h13.94a.47.47,0,0,1,.37.18.47.47,0,0,1,.07.4l-2.07,6.83A.45.45,0,0,1,345.72,120.39Zm-9.48-.9h9.15l1.79-5.93H334.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.78,113.56l-.12,0a.45.45,0,0,1-.31-.56l.79-2.75A1.73,1.73,0,0,1,349.8,109h1.56a.45.45,0,1,1,0,.9H349.8a.83.83,0,0,0-.79.6l-.79,2.75A.46.46,0,0,1,347.78,113.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-255"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297,109.08H277.38v-1H297a7.79,7.79,0,0,0,7.79-7.79V89.56h1v10.73A8.8,8.8,0,0,1,297,109.08Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 294.05,
    y: 72.43,
    width: 22.56,
    height: 22.56,
    rx: 4.4,
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.05,
    y: 72.43,
    width: 22.56,
    height: 22.56,
    rx: 4.4,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,86.07c0,.24,0,1.09-.05,1.33h-7.71V83.72h1.05L305,81.54l-2.18,2.18h1.05V87.4h-7.24c0-.12,0-.86,0-1a3.87,3.87,0,0,1,3.5-3.85v-.15A4.54,4.54,0,0,1,309,81a5.29,5.29,0,0,1,.81.08A5,5,0,0,1,313.88,86.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-255"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 250.65,
    y: 83.46,
    width: 1,
    height: 20.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.63,63.86H244.68a4.76,4.76,0,0,0-4.76,4.76V81.57a4.76,4.76,0,0,0,4.76,4.76h12.95a4.75,4.75,0,0,0,4.75-4.76V68.62A4.75,4.75,0,0,0,257.63,63.86Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.63,63.86H244.68a4.76,4.76,0,0,0-4.76,4.76V81.57a4.76,4.76,0,0,0,4.76,4.76h12.95a4.75,4.75,0,0,0,4.75-4.76V68.62A4.75,4.75,0,0,0,257.63,63.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.23,76.57c0-.15,0-.3,0-.44l.91-.36a5.6,5.6,0,0,0-.16-1.23l-1-.11a4.75,4.75,0,0,0-.33-.81l.61-.77a6.52,6.52,0,0,0-.75-1l-.9.39a5.22,5.22,0,0,0-.7-.54l.14-1a5.27,5.27,0,0,0-1.14-.48l-.58.79L249,71l-.43,0-.37-.92a6.27,6.27,0,0,0-1.22.16l-.11,1a4.56,4.56,0,0,0-.82.34l-.77-.62a6,6,0,0,0-1,.76l.39.9a5.35,5.35,0,0,0-.53.7l-1-.15a6.35,6.35,0,0,0-.47,1.14l.79.59c0,.14-.06.28-.08.43a3.25,3.25,0,0,0,0,.44l-.92.36a5.6,5.6,0,0,0,.16,1.23l1,.11a5.73,5.73,0,0,0,.33.81l-.61.77a6.52,6.52,0,0,0,.75,1l.91-.39a4.57,4.57,0,0,0,.69.54l-.14,1a5.47,5.47,0,0,0,1.14.47l.58-.79.44.08.44,0,.36.91a5.51,5.51,0,0,0,1.22-.16l.11-1a4.56,4.56,0,0,0,.82-.34l.77.61a5.42,5.42,0,0,0,1-.75l-.39-.9a5.15,5.15,0,0,0,.53-.7l1,.15a6.35,6.35,0,0,0,.47-1.14l-.79-.59C253.18,76.86,253.21,76.71,253.23,76.57ZM248,77.86a2,2,0,1,1,2.2-1.69A2,2,0,0,1,248,77.86Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.23,76.57c0-.15,0-.3,0-.44l.91-.36a5.6,5.6,0,0,0-.16-1.23l-1-.11a4.75,4.75,0,0,0-.33-.81l.61-.77a6.52,6.52,0,0,0-.75-1l-.9.39a5.22,5.22,0,0,0-.7-.54l.14-1a5.27,5.27,0,0,0-1.14-.48l-.58.79L249,71l-.43,0-.37-.92a6.27,6.27,0,0,0-1.22.16l-.11,1a4.56,4.56,0,0,0-.82.34l-.77-.62a6,6,0,0,0-1,.76l.39.9a5.35,5.35,0,0,0-.53.7l-1-.15a6.35,6.35,0,0,0-.47,1.14l.79.59c0,.14-.06.28-.08.43a3.25,3.25,0,0,0,0,.44l-.92.36a5.6,5.6,0,0,0,.16,1.23l1,.11a5.73,5.73,0,0,0,.33.81l-.61.77a6.52,6.52,0,0,0,.75,1l.91-.39a4.57,4.57,0,0,0,.69.54l-.14,1a5.47,5.47,0,0,0,1.14.47l.58-.79.44.08.44,0,.36.91a5.51,5.51,0,0,0,1.22-.16l.11-1a4.56,4.56,0,0,0,.82-.34l.77.61a5.42,5.42,0,0,0,1-.75l-.39-.9a5.15,5.15,0,0,0,.53-.7l1,.15a6.35,6.35,0,0,0,.47-1.14l-.79-.59C253.18,76.86,253.21,76.71,253.23,76.57ZM248,77.86a2,2,0,1,1,2.2-1.69A2,2,0,0,1,248,77.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.33,73.52a2.55,2.55,0,0,1-1.17-4.82v1.61a1.19,1.19,0,0,0,.35.83,1.16,1.16,0,0,0,.82.34,1.17,1.17,0,0,0,1.17-1.17V68.7a2.55,2.55,0,0,1-1.17,4.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.17,79.89V72.81a1.16,1.16,0,0,1,1.16-1.17h0a1.16,1.16,0,0,1,1.16,1.17v7.08a1.16,1.16,0,0,1-1.16,1.16h0A1.16,1.16,0,0,1,256.17,79.89Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Machine--inject-255"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.79,175.59h-1V164.86a8.81,8.81,0,0,1,8.8-8.8h19.74a7.81,7.81,0,0,0,7.8-7.8V140h1v8.28a8.81,8.81,0,0,1-8.8,8.8H215.59a7.81,7.81,0,0,0-7.8,7.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.27,174.33h-13a4.76,4.76,0,0,0-4.76,4.76V192a4.75,4.75,0,0,0,4.76,4.75h13A4.75,4.75,0,0,0,218,192V179.09A4.76,4.76,0,0,0,213.27,174.33Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.27,174.33h-13a4.76,4.76,0,0,0-4.76,4.76V192a4.75,4.75,0,0,0,4.76,4.75h13A4.75,4.75,0,0,0,218,192V179.09A4.76,4.76,0,0,0,213.27,174.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.85,190.94a1.45,1.45,0,1,1-1.45-1.45A1.45,1.45,0,0,1,214.85,190.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.43,190.94a1.45,1.45,0,1,1-1.45-1.45A1.45,1.45,0,0,1,208.43,190.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,190.94a1.46,1.46,0,1,1-1.46-1.45A1.45,1.45,0,0,1,202,190.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.73,193.84H200.16a2.82,2.82,0,0,1-2.82-2.82v-.16a2.82,2.82,0,0,1,2.82-2.82h13.57a2.82,2.82,0,0,1,2.82,2.82V191A2.82,2.82,0,0,1,213.73,193.84Zm-13.57-4.9a1.92,1.92,0,0,0-1.92,1.92V191a1.92,1.92,0,0,0,1.92,1.92h13.57a1.92,1.92,0,0,0,1.92-1.92v-.16a1.92,1.92,0,0,0-1.92-1.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6,188.91a.9.9,0,0,1-.9-.9v-2.85L207,179.21l-3.27,1.07a.9.9,0,0,1-.56-1.71l3.8-1.25a.89.89,0,0,1,.93.23l6.39,6.62a.9.9,0,0,1,.25.62V188A.9.9,0,0,1,213.6,188.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.16,182.12a.45.45,0,0,1-.45-.45v-2.24a.45.45,0,1,1,.9,0v2.24A.45.45,0,0,1,203.16,182.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.46,183.81a.44.44,0,0,1-.32-.13,1.43,1.43,0,0,1-.42-1,1.45,1.45,0,0,1,2.89,0,1.48,1.48,0,0,1-.38,1,.45.45,0,0,1-.67-.61.51.51,0,0,0,.15-.37.55.55,0,0,0-.55-.54.54.54,0,0,0-.54.54.57.57,0,0,0,.16.39.45.45,0,0,1,0,.63A.44.44,0,0,1,202.46,183.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.55,178.22a.36.36,0,1,1-.36-.35A.36.36,0,0,1,207.55,178.22Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.89,184.84a.36.36,0,1,1-.36-.36A.36.36,0,0,1,213.89,184.84Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.8,
    y: 184.81,
    width: 2.73,
    height: 2.73,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Profile--inject-255"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216,109.08H196.35a8.8,8.8,0,0,1-8.8-8.79V89.56h1v10.73a7.8,7.8,0,0,0,7.8,7.79H216Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 178.7,
    y: 71.4,
    width: 22.46,
    height: 22.46,
    rx: 4.76,
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.7,
    y: 71.4,
    width: 22.46,
    height: 22.46,
    rx: 4.76,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.93,76c2,0,3,1.58,3,3.54s-1.05,3.54-3,3.54-3-1.59-3-3.54S188,76,189.93,76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75,89.27H182.11a.48.48,0,0,1-.33-.14l1-2.74a4.47,4.47,0,0,1,4.2-2.93h5.9a4.46,4.46,0,0,1,4.2,2.93l1,2.74A.48.48,0,0,1,197.75,89.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-255"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.58,159h-1V148.27a8.8,8.8,0,0,1,8.8-8.79H225.5v1H178.38a7.8,7.8,0,0,0-7.8,7.79Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 159.24,
    y: 151.07,
    width: 22.46,
    height: 22.46,
    rx: 4.76,
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.24,
    y: 151.07,
    width: 22.46,
    height: 22.46,
    rx: 4.76,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.06,
    y: 164.35,
    width: 2.79,
    height: 5.37,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.97,
    y: 162.54,
    width: 2.79,
    height: 7.18,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.87,
    y: 160.73,
    width: 2.79,
    height: 8.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.94,
    y: 158.92,
    width: 2.79,
    height: 10.8,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-255"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168.95,
    y: 122.44,
    width: 60.32,
    height: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.88,105H157.93a4.76,4.76,0,0,0-4.76,4.76v12.95a4.76,4.76,0,0,0,4.76,4.76h12.95a4.75,4.75,0,0,0,4.75-4.76V109.79A4.75,4.75,0,0,0,170.88,105Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.88,105H157.93a4.76,4.76,0,0,0-4.76,4.76v12.95a4.76,4.76,0,0,0,4.76,4.76h12.95a4.75,4.75,0,0,0,4.75-4.76V109.79A4.75,4.75,0,0,0,170.88,105Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.9,108v2.08a6.25,6.25,0,0,1,3.53,1.46l1.47-1.47A8.28,8.28,0,0,0,164.9,108Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.9,108v2.08a6.25,6.25,0,0,1,3.53,1.46l1.47-1.47A8.28,8.28,0,0,0,164.9,108Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.89,122.47a6.21,6.21,0,0,1-5.7-5.7h-2.08a8.3,8.3,0,0,0,7.78,7.78Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.89,122.47a6.21,6.21,0,0,1-5.7-5.7h-2.08a8.3,8.3,0,0,0,7.78,7.78Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.19,115.76a6.22,6.22,0,0,1,5.7-5.7V108a8.3,8.3,0,0,0-7.78,7.78Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.19,115.76a6.22,6.22,0,0,1,5.7-5.7V108a8.3,8.3,0,0,0-7.78,7.78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.61,110.76l-1.47,1.47a6.23,6.23,0,0,1-4.24,10.24v2.08a8.3,8.3,0,0,0,5.71-13.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-255"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.47,104.13l2.81-.12,3.95,43.61h-3c-1.49-.14-1.84-1.82-2.25-5l-2.76-30.45C215.58,105,216.81,104.13,217.47,104.13Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.47,104.13l2.81-.12,3.95,43.61h-3c-1.49-.14-1.84-1.82-2.25-5l-2.76-30.45C215.58,105,216.81,104.13,217.47,104.13Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,147.62h59.11a1.15,1.15,0,0,0,1.05-1.37l-3.69-40.88a1.44,1.44,0,0,0-1.31-1.36H218a1.15,1.15,0,0,0-1.06,1.36l3.7,40.88A1.43,1.43,0,0,0,222,147.62Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.22 142.45 277.9 142.45 274.92 108.42 221.24 108.42 224.22 142.45",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,145.12h52.89a2.45,2.45,0,0,0,2.48-2.72l-2.95-33.82a3,3,0,0,0-3-2.71H221.53a2.44,2.44,0,0,0-2.48,2.71L222,142.4A3,3,0,0,0,225,145.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.22 142.45 277.9 142.45 274.92 108.42 221.24 108.42 224.22 142.45",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.22 142.45 277.9 142.45 274.92 108.42 221.24 108.42 224.22 142.45",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6,124.08l.38-.84a2.75,2.75,0,0,0,1.58.5c.66,0,.93-.22.93-.51,0-.9-2.79-.28-2.79-2.06,0-.82.65-1.5,2-1.5a3.2,3.2,0,0,1,1.66.43l-.34.84a2.74,2.74,0,0,0-1.33-.37c-.66,0-.91.24-.91.54,0,.89,2.79.28,2.79,2,0,.8-.67,1.48-2,1.48A3.41,3.41,0,0,1,228.6,124.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,122.15a2.63,2.63,0,1,1,2.62,2.48A2.48,2.48,0,0,1,233.05,122.15Zm4.13,0a1.51,1.51,0,1,0-1.51,1.54A1.47,1.47,0,0,0,237.18,122.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.25,120.65v1.26h2.22v.9h-2.22v1.74h-1.11v-4.79h3.62v.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,120.66H243v-.9h4.18v.9h-1.53v3.89h-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,119.76l-1.57,4.79h-1.19l-1.06-3.24-1.08,3.24h-1.19l-1.58-4.79h1.16l1.08,3.37,1.13-3.37h1l1.09,3.4,1.12-3.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.57,123.52h-2.22l-.43,1h-1.13l2.13-4.79H258l2.14,4.79H259Zm-.35-.84-.76-1.83-.76,1.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,124.55l-.92-1.33h-1v1.33h-1.11v-4.79h2.07c1.29,0,2.09.66,2.09,1.74a1.56,1.56,0,0,1-1,1.51l1.08,1.54Zm-1-3.89h-.9v1.67h.9c.68,0,1-.31,1-.83S263.36,120.66,262.68,120.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,123.66v.89h-3.71v-4.79h3.62v.89h-2.52v1H269v.86h-2.23v1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.73,128h1.11v4.8h-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.38,128v4.8h-.91l-2.39-2.91v2.91H228V128h.92l2.38,2.92V128Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.51,128.89H233V128h4.18v.91h-1.54v3.89h-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.47,131.89v.89h-3.71V128h3.62v.9h-2.52v1h2.23v.86h-2.23v1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.58,130.31h1v1.94a3.31,3.31,0,0,1-1.94.61,2.48,2.48,0,1,1,0-5,2.58,2.58,0,0,1,2,.83l-.72.66a1.6,1.6,0,0,0-1.23-.54,1.54,1.54,0,1,0,0,3.07,1.76,1.76,0,0,0,.86-.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.69,132.78l-.93-1.34h-1v1.34h-1.11V128h2.08c1.28,0,2.08.67,2.08,1.74a1.56,1.56,0,0,1-1,1.52l1.08,1.54Zm-1.05-3.89h-.9v1.67h.9c.68,0,1-.31,1-.84S250.32,128.89,249.64,128.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.83,131.75H253.6l-.42,1H252l2.14-4.8h1.09l2.15,4.8h-1.17Zm-.35-.84-.76-1.84-.76,1.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.68,128.89h-1.54V128h4.18v.91h-1.54v3.89h-1.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.92,128H263v4.8h-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.87,130.38a2.62,2.62,0,1,1,2.62,2.48A2.48,2.48,0,0,1,263.87,130.38Zm4.12,0a1.5,1.5,0,1,0-1.5,1.54A1.46,1.46,0,0,0,268,130.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.35,128v4.8h-.91l-2.39-2.91v2.91H270V128h.92l2.39,2.92V128Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.66 105.88 229.18 145.1 232.71 145.1 243.08 105.88 239.66 105.88",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.11 105.88 234.62 145.1 241.62 145.1 251.99 105.88 245.11 105.88",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.24 108.42 221.51 111.47 275.19 111.47 274.92 108.42 221.24 108.42",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,109.78a.55.55,0,0,1-.56.61.68.68,0,0,1-.67-.61.56.56,0,0,1,.56-.62A.69.69,0,0,1,223.71,109.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.33,109.78a.55.55,0,0,1-.56.61.68.68,0,0,1-.67-.61.56.56,0,0,1,.56-.62A.69.69,0,0,1,225.33,109.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,109.78a.55.55,0,0,1-.56.61.68.68,0,0,1-.67-.61.56.56,0,0,1,.56-.62A.69.69,0,0,1,227,109.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.39,
    y: 147.74,
    width: 62.81,
    height: 3.33,
    rx: 1.28,
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.29,147.74h62.29a0,0,0,0,1,0,0v.76a2.57,2.57,0,0,1-2.57,2.57H247.86a2.57,2.57,0,0,1-2.57-2.57v-.76A0,0,0,0,1,245.29,147.74Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.29,147.74h62.29a0,0,0,0,1,0,0v.76a2.57,2.57,0,0,1-2.57,2.57H247.86a2.57,2.57,0,0,1-2.57-2.57v-.76A0,0,0,0,1,245.29,147.74Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.36,147.83a1.67,1.67,0,0,0,1.67,1.66h7.62a1.66,1.66,0,0,0,1.66-1.66Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-255"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.28,215.42l-6.44-1.87a8.51,8.51,0,0,0-1.93-.41l-4.32-.18-3.53-1.48a1.34,1.34,0,0,0-2,1l-.23,2.38a1.36,1.36,0,0,0,.57,1.23l5.2,3.64,7.27-1.22,6.52,3.15.77-5.66Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.72,217.18l6.52-1.59a9.05,9.05,0,0,1,1.94-.33h4.32l3.59-1.32a1.33,1.33,0,0,1,2,1.09l.13,2.39a1.34,1.34,0,0,1-.61,1.2l-5.36,3.42L312,220.51l-6.65,2.87-.52-5.68Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.84 398.44 232.3 412.59 224.57 411.77 225.36 396.34 233.84 398.44",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.93,411.91a3.29,3.29,0,0,1-2.26-.77.69.69,0,0,1,.07-.8.94.94,0,0,1,.62-.39c1.33-.26,3.95,1.5,4.06,1.58a.18.18,0,0,1,.08.2.19.19,0,0,1-.16.14A12.94,12.94,0,0,1,220.93,411.91Zm-1.14-1.61a1,1,0,0,0-.35,0,.52.52,0,0,0-.39.23c-.15.22-.11.33-.06.4.32.54,2.29.7,3.77.63A8.53,8.53,0,0,0,219.79,410.3Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.31,411.87a.11.11,0,0,1-.08,0c-.9-.48-2.66-2.32-2.42-3.19,0-.21.21-.46.72-.47a1.36,1.36,0,0,1,1,.4c.94.89,1,3,1,3.12a.18.18,0,0,1-.09.16Zm-1.68-3.32-.1,0c-.34,0-.37.14-.39.19-.09.52,1.05,1.94,2,2.59a4.36,4.36,0,0,0-.85-2.48,1,1,0,0,0-.63-.28Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.22,410.83l8.54.65a.68.68,0,0,1,.64.58l1,7.07a1.16,1.16,0,0,1-1,1.31h-.25c-3.07-.29-5.8-.66-9.63-.94-4.53-.34-3.42.29-8.75,0-3.21-.19-3.52-3.88-2.15-4,6.28-.32,7.07-2.15,9.64-4.19A2.79,2.79,0,0,1,224.22,410.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.92 404.9 230.69 404.69 233.05 405.67 232.73 408.66 224.74 408.19 224.92 404.9",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.44,255.89l-14.83,88.69L235,406.77l-11.61-.2a414.48,414.48,0,0,1-1.87-67.06c1.81-32.93,9.47-71.44,10.32-82.42l4.29-7.58,8.54,1.07Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.81,414.22l6.6-.75s-.19-2.72-.52-7.11c-.07-1-.15-2-.23-3.17l-7.58,1.35H274c0,.17.07.34.1.5.16.89.33,1.71.47,2.5C275.32,411.67,275.81,414.22,275.81,414.22Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.66,411.12a.21.21,0,0,1-.18-.13.19.19,0,0,1,.06-.2c.11-.09,2.56-2.09,3.92-1.94a1,1,0,0,1,.65.33.7.7,0,0,1,.14.8c-.25.47-1.22.81-2.18,1A15,15,0,0,1,283.66,411.12Zm.55-.35c1.48-.06,3.43-.39,3.71-1,0-.07.07-.19-.1-.39a.51.51,0,0,0-.41-.2,1.45,1.45,0,0,0-.36,0A8.81,8.81,0,0,0,284.21,410.77Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.56,411.12a.16.16,0,0,1-.11-.15c0-.1-.15-2.23.71-3.2a1.34,1.34,0,0,1,1-.48c.52,0,.72.19.77.4.31.85-1.28,2.84-2.14,3.4a.1.1,0,0,1-.07,0A.15.15,0,0,1,283.56,411.12Zm1.5-3.47a1,1,0,0,0-.59.34,4.4,4.4,0,0,0-.64,2.55c.87-.73,1.87-2.25,1.74-2.76,0,0-.07-.18-.4-.15l-.11,0Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.19,410.33l-6.74,1a.7.7,0,0,0-.58.65l-.39,7.14a1.14,1.14,0,0,0,1.07,1.22,1,1,0,0,0,.25,0c3-.56,4-.82,7.8-1.44,4.49-.74,3.44,0,8.73-.81,3.18-.49,3.17-4.19,1.79-4.15C287.83,414.21,282.85,410.19,282.19,410.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.54,407.55l7.35-1.19c-.07-1-.15-2-.23-3.17l-7.58,1.35v.51C274.23,405.94,274.4,406.76,274.54,407.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89,276.49l-4,23.71c-1.19-17,.4-37.23.4-37.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.16,253.68s9.42,68.44,12.93,86.05c3.12,15.64,3.69,65.11,3.69,65.11L272.45,406s-5.9-27.22-7.85-46.36c-.68-6.68-.49-12.28-1.1-15.72-.81-4.54-27.15-77.84-22.25-89.41Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.44,244.5a50.77,50.77,0,0,0,.25-8.92c-2.37-28.3-3.22-30-3-35a2.19,2.19,0,0,1,1.47-2c19.58-6.66,34.81-3.5,39.23-1,5.89,3.32,3.54,6.87,3.47,7.88-.57,8.39-5.19,23.94-5.29,37.55,0,2,.2,6.8.33,9.46a2.19,2.19,0,0,1-1.75,2.25c-4.39.91-23.65,1.15-27.26,1-3.45-.12-5.72-.33-7.17-.52a2.18,2.18,0,0,1-1.83-2.64C230.45,250.17,231.27,246.27,231.44,244.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,181.39c-.74,4.38-.44,10.81,2.69,13.66,0,0-.06,4.46-12.3,9.58-4.62-6.28-1.34-9.25-1.34-9.25,4.87-1.28,3.69-3.27,2.76-6.65Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.67,184.34l-4.82,4.39a13.86,13.86,0,0,1,.48,2.39c1.87-.31,4.76-2,5.11-4A5.89,5.89,0,0,0,251.67,184.34Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.52,173.75c-1.78,7.21-2.39,10.29-6.76,13.35-6.58,4.62-15,.84-15.45-6.76-.36-6.84,2.64-17.52,10.31-19.07a10.14,10.14,0,0,1,11.9,12.48Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,172.82c-.12.59-.52,1-.9,1s-.62-.62-.51-1.21.52-1,.9-.95S248.09,172.25,248,172.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.36,171.66c-.11.6-.52,1-.9,1s-.62-.62-.51-1.21.52-1,.9-.94S241.47,171.06,241.36,171.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.71,173.75a16.15,16.15,0,0,1-2.82,3.4,2.61,2.61,0,0,0,2.05.79Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.74,180.86a5.39,5.39,0,0,1-.89-.1.17.17,0,0,1-.14-.2h0a.17.17,0,0,1,.21-.14,4.81,4.81,0,0,0,4.17-1.14.18.18,0,0,1,.26.25A5,5,0,0,1,245.74,180.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.17,171.91a.34.34,0,0,1-.37-.19,4.18,4.18,0,0,0-2.81-1.84.36.36,0,0,1-.3-.41.35.35,0,0,1,.4-.29h0a4.8,4.8,0,0,1,3.34,2.23.36.36,0,0,1-.16.47h0A.23.23,0,0,1,251.17,171.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.19,169.35a.36.36,0,0,1-.35-.11.35.35,0,0,1,0-.5,3.48,3.48,0,0,1,3.13-.93.33.33,0,0,1,.26.4v0a.35.35,0,0,1-.42.26h0a2.81,2.81,0,0,0-2.45.77A.34.34,0,0,1,240.19,169.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,194.61l-1.29-.22-7.17,3.91-2.22.08-4.26-3.62-1.43.34h0a25.27,25.27,0,0,0-.74,12.71l2.41,12.1,2.52,13.25h0l.54-1.22,2-4.56,2.74-5.2,5-12.72,1.42-5.24a22.23,22.23,0,0,0,.43-9.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.27,198.39c-7.69.07-8.54-2.76-8.54-2.76V195s-2.32,4.37,4.35,5.14,11.12-2.39,12.07-4.29h0C258.41,196.81,256.42,198.35,251.27,198.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.24,163.84a6.62,6.62,0,0,0-1.61-3.12,2.29,2.29,0,0,0-3.18-.07,6.38,6.38,0,0,0-5.26-2.14,5.74,5.74,0,0,0-4.51,2.92c-.89,1.65-3.7,2.23-5.56,2.42,1.22,1.23,4.24,2,5.75,1.17-.37.58-2.06.89-2.75,1a9.65,9.65,0,0,0,3.63,1.29,3.24,3.24,0,0,0,3.24-1.66,2.51,2.51,0,0,0,.33,3,2.54,2.54,0,0,0,3,.48,1.43,1.43,0,0,1-1-1.47,1.67,1.67,0,0,1,1.16-1.54,3.56,3.56,0,0,0,1.27,2.37c.66.51,1.24.72,1.65,1.45s-.08,2.5-1.39,2.38c.59.63,3,.4,3.27-.42a7.32,7.32,0,0,1-3.62,4.93,4.62,4.62,0,0,1,1.4.3,2,2,0,0,1,1.27.91,2.85,2.85,0,0,1-.09,2.18,45.6,45.6,0,0,1-2.16,5.44,8.16,8.16,0,0,0,5.39-4.69,5.49,5.49,0,0,0,3.69-5.57,7.1,7.1,0,0,0,2.28-4,3.07,3.07,0,0,0-2.3-3.38,3.55,3.55,0,0,0-.54-3.6A2.41,2.41,0,0,0,260.24,163.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.22,179a5,5,0,0,1-3,2.34c-1.69.45-2.52-1.08-2-2.68.45-1.43,1.87-3.39,3.57-3.16a2.25,2.25,0,0,1,1.84,2.6A2.15,2.15,0,0,1,260.22,179Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,173.81l-4.92-.84c-.41-1.26-2.19-1.56-2.94-1.69s-2.66-.45-3.42.76l-1.71-.3c-.32-1.38-2.2-1.71-3-1.84s-3.35-.57-3.71,1.51a3.42,3.42,0,0,0,6.7,1.15,2,2,0,0,0,0-.34l1.47.25a2.66,2.66,0,0,0-.08.33,3.42,3.42,0,0,0,6.7,1.14,2.75,2.75,0,0,0,0-.49l4.76.82a2.82,2.82,0,0,1,1.67.94l.35-.3A3.29,3.29,0,0,0,257,173.81Zm-16.76.72a2.78,2.78,0,0,1-2.46-3c.2-1.14,1.14-1.48,3.17-1.14s2.81,1,2.61,2.13A2.78,2.78,0,0,1,240.22,174.53Zm8.11,1.38a2.77,2.77,0,0,1-2.45-3c.19-1.14,1.14-1.48,3.17-1.13s2.8,1,2.61,2.12A2.78,2.78,0,0,1,248.33,175.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,214.46A61.6,61.6,0,0,0,214.6,216a56.61,56.61,0,0,1,15.6-17.5L233,209s-8.34,13.25-15.09,16.3c-5.35,2.42-21.4-1.89-27.84-3.79A16.15,16.15,0,0,1,192,214.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.43,215.64a61.69,61.69,0,0,1-22.59,1,56.43,56.43,0,0,0-15.21-17.84l-3,10.43s8.05,13.44,14.74,16.63c5.29,2.53,21.43-1.43,27.91-3.18A16.23,16.23,0,0,0,308.43,215.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.76,192.79l0,2.84s.6,3.08,8.29,3,8.59-3.71,8.59-3.71l0-2.06a2.34,2.34,0,0,0-2.78-2.33,36.9,36.9,0,0,1-11.46,0A2.34,2.34,0,0,0,242.76,192.79Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.78a5260869d3350f4fedb22fb6329dff.svg";
export { ForwardRef as ReactComponent };